import React from 'react'
import { string, func, any } from 'prop-types'
import { translate } from 'react-i18next'

import RadioGroup from './RadioGroup'
import Radio from './Radio'

const DisponibilityRadioComponent = ({ t, name, value, onChange }) => {
  return (<RadioGroup className='' name={name} onChange={(value) => onChange(value)} selectedValue={value} >
    <div className='form__input__container'>
      <Radio value='full'>
        <p className='disponibility__text'>Journée entière</p>
        <p className='disponibility__hours'>8:00 - 19:00</p>
      </Radio>
      <Radio value='am'>
        <p className='disponibility__text'> Matin</p>
        <p className='disponibility__hours'>8:00 - 13:00</p>
      </Radio>
    </div>
    <div className='form__input__container'>
      <Radio value='pm'>
        <p className='disponibility__text'>Après-midi</p>
        <p className='disponibility__hours'>13:00 - 19:00</p>
      </Radio>
    </div>
  </RadioGroup>)
}

DisponibilityRadioComponent.propTypes = {
  t: func,
  name: string,
  value: any,
  onChange: func
}

export const DisponibilityRadio = translate()(DisponibilityRadioComponent)

/* export default class DisponibilityRadio extends Component {
  constructor () {
    super()

    this.state = {
      value: '',
      perso: {
        hours1: '08',
        min1: '00',
        hours2: '19',
        min2: '00'
      }
    }

    this.handleChange = this.handleChange.bind(this)
    this.handlePersoChange = this.handlePersoChange.bind(this)
  }

  handleChange (value) {
    this.setState({value: value})
    this.props.onChange(value, this.state.perso)
  }

  handlePersoChange (value, name) {
    let persoValue = {[name]: value}
    let statePerso = {...this.state.perso}
    this.setState({
      perso: {...this.state.perso, ...persoValue}
    })
    statePerso = {...statePerso, ...persoValue}
    this.props.onChange(this.state.value, statePerso)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ value: nextProps.selectedValue })
  }

  render () {
    return (
      <RadioGroup className='' name={this.props.name} onChange={this.handleChange} selectedValue={this.state.value} >
        <div className='form__input__container'>
          <Radio value='full'>
            <p className='disponibility__text'>Journée entière</p>
            <p className='disponibility__hours'>8:00 - 19:00</p>
          </Radio>
          <Radio value='am'>
            <p className='disponibility__text'> Matin</p>
            <p className='disponibility__hours'>8:00 - 13:00</p>
          </Radio>
        </div>
        <div className='form__input__container'>
          <Radio value='pm'>
            <p className='disponibility__text'>Après-midi</p>
            <p className='disponibility__hours'>13:00 - 19:00</p>
          </Radio>
          <Radio value='perso'>
            <p className='disponibility__text'>Personnalisé</p>
            <div className='disponibility__select'>
              <SelectGroup selectedValue={this.state.perso.hours1} onChange={this.handlePersoChange} name='hours1'>
                <Select value='8'>08</Select>
                <Select value='9'>09</Select>
                <Select value='10'>10</Select>
                <Select value='11'>11</Select>
                <Select value='12'>12</Select>
                <Select value='13'>13</Select>
                <Select value='14'>14</Select>
                <Select value='15'>15</Select>
                <Select value='16'>16</Select>
                <Select value='17'>17</Select>
                <Select value='18'>18</Select>
                <Select value='19'>19</Select>
              </SelectGroup>
              <span className=''>:</span>
              <SelectGroup selectedValue={this.state.perso.min1} onChange={this.handlePersoChange} name='min1'>
                <Select value='0'>00</Select>
                <Select value='15'>15</Select>
                <Select value='30'>30</Select>
                <Select value='45'>45</Select>
              </SelectGroup>
              <span>-</span>
              <SelectGroup selectedValue={this.state.perso.hours2} onChange={this.handlePersoChange} name='hours2'>
                <Select value='8'>08</Select>
                <Select value='9'>09</Select>
                <Select value='10'>10</Select>
                <Select value='11'>11</Select>
                <Select value='12'>12</Select>
                <Select value='13'>13</Select>
                <Select value='14'>14</Select>
                <Select value='15'>15</Select>
                <Select value='16'>16</Select>
                <Select value='17'>17</Select>
                <Select value='18'>18</Select>
                <Select value='19'>19</Select>
              </SelectGroup>
              <span className=''>:</span>
              <SelectGroup selectedValue={this.state.perso.min2} onChange={this.handlePersoChange} name='min2'>
                <Select value='0'>00</Select>
                <Select value='15'>15</Select>
                <Select value='30'>30</Select>
                <Select value='45'>45</Select>
              </SelectGroup>
            </div>
          </Radio>
        </div>
      </RadioGroup>
    )
  }
} */



// WEBPACK FOOTER //
// ./src/components/ui/inputs/DisponibilityRadio.js